
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const create_ticket = createAsyncThunk(
    'ticket/create_ticket',
    async (ticketData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/home/tickets/create', ticketData)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const create_vendor_application = createAsyncThunk(
    'ticket/create_vendor_application',
    async (applicationData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/home/vendor-applications/create', applicationData)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const get_my_vendor_application = createAsyncThunk(
    'ticket/get_my_vendor_application',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/vendor-applications/mine')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const get_my_tickets = createAsyncThunk(
    'ticket/get_my_tickets',
    async (email, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/tickets/my-tickets', { params: { email } })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const get_ticket_detail = createAsyncThunk(
    'ticket/get_ticket_detail',
    async (ticketId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/tickets/${ticketId}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Ticket tapılmadı' })
        }
    }
)

// FormData yox, sadə JSON göndər — backend req.body.reply oxuyur
export const send_ticket_message = createAsyncThunk(
    'ticket/send_ticket_message',
    async ({ ticketId, reply, customerEmail }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(
                `/home/tickets/${ticketId}/customer-reply`,
                { reply, customerEmail }
            )
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Göndərilmədi' })
        }
    }
)

// Backend responses[] → frontend messages[] normalize
const normalizeTicket = (ticket) => {
    if (!ticket) return null
    const responses = ticket.responses || []
    const messages = responses.map(r => ({
        ...r,
        senderRole: r.isCustomer ? 'user' : 'admin',
        message: r.message || ''
    }))
    return { ...ticket, messages }
}

const ticketReducer = createSlice({
    name: 'ticket',
    initialState: {
        loader: false,
        successMessage: '',
        errorMessage: '',
        ticketNumber: null,
        applicationNumber: null,
        myApplication: null,
        myApplicationChecked: false,
        myTickets: [],
        ticketDetail: null,
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        },
        clearTicketDetail: (state) => {
            state.ticketDetail = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(create_ticket.pending,   (state) => { state.loader = true })
            .addCase(create_ticket.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                state.ticketNumber = payload.ticketNumber
            })
            .addCase(create_ticket.rejected,  (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Xəta baş verdi'
            })

            .addCase(create_vendor_application.pending,   (state) => { state.loader = true })
            .addCase(create_vendor_application.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                state.applicationNumber = payload.applicationNumber
            })

            .addCase(get_my_vendor_application.fulfilled, (state, { payload }) => {
                state.myApplication = payload.application || null
                state.myApplicationChecked = true
            })
            .addCase(get_my_vendor_application.rejected, (state) => {
                state.myApplicationChecked = true
            })
            .addCase(create_vendor_application.rejected,  (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Xəta baş verdi'
            })

            .addCase(get_my_tickets.pending,   (state) => { state.loader = true })
            .addCase(get_my_tickets.fulfilled, (state, { payload }) => {
                state.loader = false
                state.myTickets = payload.tickets || []
            })
            .addCase(get_my_tickets.rejected,  (state) => { state.loader = false })

            .addCase(get_ticket_detail.pending,   (state) => { state.loader = true })
            .addCase(get_ticket_detail.fulfilled, (state, { payload }) => {
                state.loader = false
                state.ticketDetail = normalizeTicket(payload.ticket || payload.data || payload)
            })
            .addCase(get_ticket_detail.rejected,  (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Ticket tapılmadı'
            })

            .addCase(send_ticket_message.pending,   (state) => { state.loader = true })
            .addCase(send_ticket_message.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message || 'Göndərildi'
                if (payload.ticket || payload.data) {
                    state.ticketDetail = normalizeTicket(payload.ticket || payload.data)
                }
            })
            .addCase(send_ticket_message.rejected,  (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Göndərilmədi'
            })
    }
})

export const { messageClear, clearTicketDetail } = ticketReducer.actions
export default ticketReducer.reducer